"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOnlinePayment = exports.getUpToDateMetadata = exports.serializeForRefund = exports.getMaximumRefundableAmountForOnlinePayment = exports.getMaxRefundableAmount = exports.getMaximumRefundableAmount = exports.getOriginalRefundTransaction = exports.handleRefundStatus = void 0;
const homi_shared_1 = require("@getgreenline/homi-shared");
const enums_1 = require("./enums");
const utils_1 = require("../payment/utils");
const BlazepayAPI_1 = require("../../../api/blazepay/BlazepayAPI");
const enums_2 = require("../payment/enums");
const products_1 = require("@getgreenline/products");
const handleRefundStatus = (response) => {
    switch (response.attributes.status) {
        case enums_1.RefundStatus.PENDING:
        case enums_1.RefundStatus.UNKNOWN:
            return;
        case enums_1.RefundStatus.REFUNDED:
            return;
        case enums_1.RefundStatus.FAILED:
            throw new Error(response.attributes.failReason || 'Refund failed');
        default:
            throw new Error('Refund status is not updated. Please check the terminal and try again.');
    }
};
exports.handleRefundStatus = handleRefundStatus;
const getOriginalRefundTransaction = (currentRefundPayment, originalPaymentTransactions, paymentTypeId) => {
    const provider = (0, utils_1.getProvider)(paymentTypeId);
    if (!provider)
        return;
    const currentRefundPaymentServiceTransactionIds = currentRefundPayment.transactions
        .filter((transaction) => transaction.paymentTypeId === paymentTypeId)
        .map((transaction) => { var _a; return (_a = (0, utils_1.parseTransactionFromMetadata)(transaction)) === null || _a === void 0 ? void 0 : _a.id; });
    return originalPaymentTransactions.find((transaction) => {
        const originalBlazeTransaction = (0, utils_1.parseTransactionFromMetadata)(transaction);
        if (!originalBlazeTransaction)
            return false;
        const isDuplicate = (originalBlazeTransaction === null || originalBlazeTransaction === void 0 ? void 0 : originalBlazeTransaction.id) &&
            currentRefundPaymentServiceTransactionIds.includes(originalBlazeTransaction === null || originalBlazeTransaction === void 0 ? void 0 : originalBlazeTransaction.id);
        return transaction.paymentTypeId === paymentTypeId && !isDuplicate;
    });
};
exports.getOriginalRefundTransaction = getOriginalRefundTransaction;
const getMaximumRefundableAmount = (transaction, originalTransaction) => {
    var _a, _b, _c;
    const useTransaction = originalTransaction && (0, utils_1.isManualTransaction)(originalTransaction)
        ? originalTransaction
        : transaction;
    const originalTransactionFromMetadata = (0, utils_1.parseTransactionFromMetadata)(useTransaction);
    const chargedAmount = ((_a = originalTransactionFromMetadata === null || originalTransactionFromMetadata === void 0 ? void 0 : originalTransactionFromMetadata.attributes) === null || _a === void 0 ? void 0 : _a.chargedAmount) || 0;
    const tipAmount = ((_b = originalTransactionFromMetadata === null || originalTransactionFromMetadata === void 0 ? void 0 : originalTransactionFromMetadata.attributes) === null || _b === void 0 ? void 0 : _b.tipAmount) || 0;
    const originalTransactionAmount = (_c = originalTransactionFromMetadata === null || originalTransactionFromMetadata === void 0 ? void 0 : originalTransactionFromMetadata.originalTransactionAmount) !== null && _c !== void 0 ? _c : 0;
    const maxRefundableAmount = originalTransaction && (0, utils_1.isManualTransaction)(originalTransaction)
        ? originalTransactionAmount
        : chargedAmount - tipAmount;
    return maxRefundableAmount || undefined;
};
exports.getMaximumRefundableAmount = getMaximumRefundableAmount;
const getMaxRefundableAmount = (transaction, originalPayment, refundPayment, index) => {
    const calculateNewMaxRefundableAmount = index !== undefined && originalPayment && refundPayment;
    if (calculateNewMaxRefundableAmount) {
        return getMaximumRefundableAmountForTransactions(originalPayment, refundPayment, index);
    }
    else {
        return (0, exports.getMaximumRefundableAmount)(transaction); // OLD Calculation
    }
};
exports.getMaxRefundableAmount = getMaxRefundableAmount;
const getMaximumRefundableAmountForTransactions = (originalPayment, refundPayment, index) => {
    var _a;
    if (!originalPayment || !refundPayment)
        return 0;
    let totalTipFromPaymentLines = originalPayment.paymentLines.reduce((acc, line) => (line.sku === products_1.ProductModels.ProductType.TIP ? acc + line.price : acc), 0) || 0;
    const mappedTransactions = refundPayment.transactions.map((refund, idx) => {
        var _a, _b, _c, _d, _e;
        const parsedRefund = (0, utils_1.parseTransactionFromMetadata)(refund);
        return {
            key: `${(_a = parsedRefund === null || parsedRefund === void 0 ? void 0 : parsedRefund.attributes) === null || _a === void 0 ? void 0 : _a.authCode}_${idx}`, // stable key
            amount: (_c = ((parsedRefund === null || parsedRefund === void 0 ? void 0 : parsedRefund.originalTransactionAmount) || ((_b = parsedRefund === null || parsedRefund === void 0 ? void 0 : parsedRefund.attributes) === null || _b === void 0 ? void 0 : _b.requestedAmount))) !== null && _c !== void 0 ? _c : 0,
            manualTip: (_e = (_d = parsedRefund === null || parsedRefund === void 0 ? void 0 : parsedRefund.attributes) === null || _d === void 0 ? void 0 : _d.tipAmount) !== null && _e !== void 0 ? _e : 0,
            maxRefundAmount: 0,
        };
    });
    // Calculate removed transactions amount from original payment
    const removedTransactionsAmount = originalPayment.transactions
        .filter((t) => !refundPayment.transactions.some((ft) => ft.metadata === t.metadata))
        .reduce((acc, t) => {
        const parsed = (0, utils_1.parseTransactionFromMetadata)(t);
        return acc + ((parsed === null || parsed === void 0 ? void 0 : parsed.originalTransactionAmount) || 0);
    }, 0);
    const totalManualTips = originalPayment.transactions.reduce((acc, t) => {
        var _a;
        const parsed = (0, utils_1.parseTransactionFromMetadata)(t);
        return acc + (((_a = parsed === null || parsed === void 0 ? void 0 : parsed.attributes) === null || _a === void 0 ? void 0 : _a.tipAmount) || 0);
    }, 0);
    // Calculate max refund per refund transaction
    mappedTransactions.forEach((val, idx) => {
        const nonManualTips = totalTipFromPaymentLines - totalManualTips;
        let maxRefund = val.amount + (idx === 0 ? removedTransactionsAmount - nonManualTips : -nonManualTips);
        if (maxRefund < 0) {
            totalTipFromPaymentLines = Math.abs(maxRefund) + totalManualTips; // Adjust remaining tips for next iterations
            maxRefund = 0;
        }
        else {
            totalTipFromPaymentLines = totalManualTips; // Update value
        }
        val.maxRefundAmount = maxRefund;
    });
    const target = mappedTransactions[index !== null && index !== void 0 ? index : 0];
    return (_a = target === null || target === void 0 ? void 0 : target.maxRefundAmount) !== null && _a !== void 0 ? _a : 0;
};
const getMaximumRefundableAmountForOnlinePayment = (transaction) => {
    if (!transaction.metadata)
        return;
    const parsedTransactionMetadata = JSON.parse(transaction.metadata);
    const type = parsedTransactionMetadata === null || parsedTransactionMetadata === void 0 ? void 0 : parsedTransactionMetadata.type;
    if (!type)
        return;
    const attributes = parsedTransactionMetadata === null || parsedTransactionMetadata === void 0 ? void 0 : parsedTransactionMetadata.attributes;
    if (!attributes)
        return;
    const chargedAmount = attributes === null || attributes === void 0 ? void 0 : attributes.chargedAmount;
    const requestedAmount = attributes === null || attributes === void 0 ? void 0 : attributes.requestedAmount;
    if (!chargedAmount) {
        return requestedAmount || undefined;
    }
    const tipAmount = (attributes === null || attributes === void 0 ? void 0 : attributes.tipAmount) || 0;
    return chargedAmount - tipAmount;
};
exports.getMaximumRefundableAmountForOnlinePayment = getMaximumRefundableAmountForOnlinePayment;
const serializeForRefund = ({ paymentRes, refundRes, deviceId, currentUserId, reason, transaction, }) => {
    if (paymentRes) {
        const transactionAmount = Math.abs(transaction.amount);
        if (transactionAmount == null)
            throw new Error('Original transaction amount is not found');
        return {
            deviceId,
            transactionAmount,
            currentShiftId: currentUserId,
            paymentId: paymentRes.id,
            reason,
        };
    }
    else if (refundRes) {
        return {
            deviceId,
            transactionAmount: refundRes.attributes.requestedAmount,
            currentShiftId: currentUserId,
            paymentId: refundRes.attributes.paymentId,
            reason,
        };
    }
    else {
        throw new Error('Original payment not found. Please use a different refund method.');
    }
};
exports.serializeForRefund = serializeForRefund;
const getUpToDateMetadata = async (merchantId, transaction, paymentOptions) => {
    var _a, _b, _c;
    if (!transaction.metadata) {
        return;
    }
    const parsedMetadata = JSON.parse(transaction.metadata);
    if (((_a = parsedMetadata === null || parsedMetadata === void 0 ? void 0 : parsedMetadata.attributes) === null || _a === void 0 ? void 0 : _a.status) === enums_2.PaymentStatus.CAPTURED ||
        ((_b = parsedMetadata === null || parsedMetadata === void 0 ? void 0 : parsedMetadata.attributes) === null || _b === void 0 ? void 0 : _b.isManualPayment)) {
        return;
    }
    let provider;
    if (parsedMetadata === null || parsedMetadata === void 0 ? void 0 : parsedMetadata.paymentOptionId) {
        const paymentOption = paymentOptions.find((option) => option.id === (parsedMetadata === null || parsedMetadata === void 0 ? void 0 : parsedMetadata.paymentOptionId));
        provider = (_c = paymentOption === null || paymentOption === void 0 ? void 0 : paymentOption.attributes) === null || _c === void 0 ? void 0 : _c.provider;
    }
    else {
        provider = (0, utils_1.getProvider)(transaction.paymentTypeId);
    }
    if (!provider || !(parsedMetadata === null || parsedMetadata === void 0 ? void 0 : parsedMetadata.id)) {
        return;
    }
    const fetchRecentData = await (0, BlazepayAPI_1.getSaleTransaction)({
        merchantId,
        providerName: provider,
        transactionId: parsedMetadata.id,
    });
    if (!fetchRecentData) {
        return;
    }
    const updatedMetadata = fetchRecentData.data;
    return JSON.stringify(updatedMetadata);
};
exports.getUpToDateMetadata = getUpToDateMetadata;
const isOnlinePayment = (transaction) => {
    if (transaction.paymentTypeId !== homi_shared_1.PaymentTypeIds.online)
        return false;
    return (0, utils_1.isPaymentServiceTransactionMetadata)(transaction);
};
exports.isOnlinePayment = isOnlinePayment;
//# sourceMappingURL=utils.js.map